import { addDays, format, getWeek } from "date-fns"

export const getUrlParams = () => {
    const url = window.location.href.split('?')[1]
    const urlParams = new URLSearchParams(url)
    const paramsObj = Object.fromEntries(urlParams)
    return paramsObj
}

export const getFirebaseDocs = snapshot => {
    var data = []
    for (let row of snapshot.docs) {
        data.push({ id: row.id, ...row.data() })
    }
    return data
}

export const removeTrailingSlash = social => {
    if (social[social.length - 1] === '/') {
        social = social.slice(0, -1);
    }
    return social
}

export const getSeconds = () => parseInt(new Date().getTime() / 1000)


export const randomString = (length = 30) => [...Array(length)].map(() => Math.random().toString(36)[2]).join('')

export const reverseDateString = (date, hasDate) => {
    if (hasDate) {
        return date.split('-')[2] + '/' + date.split('-')[1] + '/' + date.split('-')[0]
    } else {
        return date.split('-')[1] + '/' + date.split('-')[0] + '/' + format(new Date(), 'dd')
    }
}

// IMPORTANT: Same information is used in app. If updating, update there as well.
const sportsOne = ["Week 1: AFL", "Week 2: AFL", "Week 3: AFL", "Week 1: Basketball", "Week 2: Basketball", "Week 3: Basketball", "Week 1: Cricket", "Week 2: Cricket", "Week 3: Cricket", "Week 1: NFL", "Week 2: NFL", "Week 3: NFL", "Week 1: Soccer", "Week 2: Soccer", "Week 3: Soccer", "Week 1: Hockey", "Week 2: Hockey", "Week 3: Hockey", "Week 1: Rugby", "Week 2: Rugby", "Week 3: Rugby", "Week 1: Tennis", "Week 2: Tennis", "Week 3: Tennis", "Week 4: AFL", "Week 5: AFL", "Week 6: AFL", "Week 4: Basketball", "Week 5: Basketball", "Week 6: Basketball", "Week 4: Cricket", "Week 5: Cricket", "Week 6: Cricket", "Week 4: NFL", "Week 5: NFL", "Week 6: NFL", "Week 4: Soccer", "Week 5: Soccer", "Week 6: Soccer", "Week 4: Hockey", "Week 5: Hockey", "Week 6: Hockey", "Week 4: Rugby", "Week 5: Rugby", "Week 6: Rugby", "Week 4: Tennis", "Week 5: Tennis", "Week 6: Tennis"]
const sportsTwo = ["Week 1: Soccer", "Week 2: Soccer", "Week 3: Soccer", "Week 1: Hockey", "Week 2: Hockey", "Week 3: Hockey", "Week 1: Rugby", "Week 2: Rugby", "Week 3: Rugby", "Week 1: Tennis", "Week 2: Tennis", "Week 3: Tennis", "Week 1: AFL", "Week 2: AFL", "Week 3: AFL", "Week 1: Basketball", "Week 2: Basketball", "Week 3: Basketball", "Week 1: Cricket", "Week 2: Cricket", "Week 3: Cricket", "Week 1: NFL", "Week 2: NFL", "Week 3: NFL", "Week 4: Soccer", "Week 5: Soccer", "Week 6: Soccer", "Week 4: Hockey", "Week 5: Hockey", "Week 6: Hockey", "Week 4: Rugby", "Week 5: Rugby", "Week 6: Rugby", "Week 4: Tennis", "Week 5: Tennis", "Week 6: Tennis", "Week 4: AFL", "Week 5: AFL", "Week 6: AFL", "Week 4: Basketball", "Week 5: Basketball", "Week 6: Basketball", "Week 4: Cricket", "Week 5: Cricket", "Week 6: Cricket", "Week 4: NFL", "Week 5: NFL", "Week 6: NFL"]
const offerSportsOne = ["Week 2: AFL", "Week 2: Basketball", "Week 2: Cricket", "Week 2: Rugby"]
const offerSportsTwo = ["Week 2: Soccer", "Week 2: Hockey", "Week 2: NFL", "Week 2: Tennis"]
const music = ["Week 1:Shakers", "Week 2:Shakers", "Week 3:Shakers", "Week 1:Tambourines", "Week 2:Tambourines", "Week 3:Tambourines", "Week 1:Xylophones", "Week 2:Xylophones", "Week 3:Xylophones", "Week 1:Rhythm Sticks", "Week 2:Rhythm Sticks", "Week 3:Rhythm Sticks", "Week 1:Triangles", "Week 2:Triangles", "Week 3:Triangles", "Week 1:Ukuleles", "Week 2:Ukuleles", "Week 3:Ukuleles", "Week 1:Big Band", "Week 2:Big Band", "Week 3:Big Band", "Week 1:Genres", "Week 2:Genres", "Week 3:Genres", "Week 1:Scales", "Week 2:Scales", "Week 3:Scales", "Week 1:Beats & Time Signatures", "Week 2:Beats & Time Signatures", "Week 3:Beats & Time Signatures", "Week 1:Dynamics & Muting", "Week 2:Dynamics & Muting", "Week 3:Dynamics & Muting", "Week 1:Advanced Ukulele", "Week 2:Advanced Ukulele", "Week 3:Advanced Ukulele", "Week 1:Drums", "Week 2:Drums", "Week 3:Drums", "Week 1:Melody And Harmony", "Week 2:Melody And Harmony", "Week 3:Melody And Harmony", "Week 1:Form, Structure and Sound", "Week 2:Form, Structure and Sound", "Week 3:Form, Structure and Sound", "Week 1:Creative Expression", "Week 2:Creative Expression", "Week 3:Creative Expression"]
const offerMusic = ["Week 2:Tambourines", "Week 2:Xylophones", "Week 2:Rhythm Sticks", "Week 2:Triangles"]

const musicFastOne = ["Week 1:Shakers", "Week 2:Shakers", "Week 3:Shakers", "Week 1:Tambourines", "Week 2:Tambourines", "Week 3:Tambourines", "Week 1:Xylophones", "Week 2:Xylophones", "Week 3:Xylophones", "Week 1:Rhythm Sticks"]
const musicFastTwo = ["Week 2:Shakers", "Week 2:Tambourines", "Week 1:Xylophones", "Week 3:Xylophones", "Week 1:Rhythm Sticks", "Week 3:Rhythm Sticks", "Week 1:Triangles", "Week 3:Triangles", "Week 1:Ukuleles", "Week 2:Ukuleles"]
const musicFastThree = ["Week 1:Shakers", "Week 3:Tambourines", "Week 3:Xylophones", "Week 3:Rhythm Sticks", "Week 3:Triangles", "Week 3:Ukuleles", "Week 3:Big Band", "Week 3:Genres", "Week 3:Scales"]
const musicFastFour = ["Week 1:Shakers/Tambourines", "Week 3:Xylophones/Rhythm Sticks", "Week 3:Triangles/Ukuleles", "Week 3:Big Band/Genres", "Week 3:Scales"]

const musicFastTracks = {
    musicFastOne,
    musicFastTwo,
    musicFastThree,
    musicFastFour
}


const gymFastOne = ["Week 2:Shapes/Fundamentals", "Week 2:Balance/Coordination", "Week 2:Jumping and Roll Introduction", "Week 1:Rolls", "Week 2:Rolls", "Week 2:Rhythm Gymnastics/Ball Skills + Handstand Introduction", "Week 1:Handstands + Cartwheel Introduction", "Week 2:Handstands + Cartwheel Introduction", "Week 1:Cartwheels + Advanced Balance", "Week 2:Cartwheels + Advanced Balance"]
const gymFastTwo = ["Week 2:Shapes/Fundamentals", "Week 2:Balance/Coordination", "Week 2:Jumping and Roll Introduction", "Week 2:Rolls", "Week 2:Rhythm Gymnastics/Ball Skills + Handstand Introduction", "Week 2:Handstands + Cartwheel Introduction", "Week 2:Cartwheels + Advanced Balance", "Week 2:Advanced Jumping and Coordination", "Week 2:Bridges and High Kicks", "Week 2:Turns and Leaps"]
const gymFastThree = ["Week 2:Shapes/Fundamentals", "Week 2:Jumping and Roll Introduction", "Week 2:Rolls", "Week 3:Rolls", "Week 2:Handstands + Cartwheel Introduction", "Week 2:Bridges and High Kicks", "Week 2:Advanced Jumping and Coordination", "Week 2:Rolls and Extension passes", "Week 2:Cartwheel Extensions and Jumps", "Week 2:Advanced Fundamentals and Rhythm Gymnastics"]
const gymFastFour = ["Week 2:Jumping and Roll Introduction", "Week 2:Rolls", "Week 2:Handstands + Cartwheel Introduction", "Week 2:Bridges and High Kicks", "Week 2:Advanced Jumping and Coordination", "Week 2:Rolls and Extension passes", "Week 2:Cartwheel Extensions and Jumps", "Week 2:Advanced Balance and Rolls"]

const gymFastTracks = {
    gymFastOne,
    gymFastTwo,
    gymFastThree,
    gymFastFour,
}

const gymnastics = ["Week 1:Shapes/Fundamentals", "Week 2:Shapes/Fundamentals", "Week 3:Shapes/Fundamentals", "Week 1:Balance/Coordination", "Week 2:Balance/Coordination", "Week 3:Balance/Coordination", "Week 1:Jumping and Roll Introduction", "Week 2:Jumping and Roll Introduction", "Week 3:Jumping and Roll Introduction", "Week 1:Rolls", "Week 2:Rolls", "Week 3:Rolls", "Week 1:Rhythm Gymnastics/Ball Skills + Handstand Introduction", "Week 2:Rhythm Gymnastics/Ball Skills + Handstand Introduction", "Week 3:Rhythm Gymnastics/Ball Skills + Handstand Introduction", "Week 1:Handstands + Cartwheel Introduction", "Week 2:Handstands + Cartwheel Introduction", "Week 3:Handstands + Cartwheel Introduction", "Week 1:Cartwheels + Advanced Balance", "Week 2:Cartwheels + Advanced Balance", "Week 3:Cartwheels + Advanced Balance", "Week 1:Bridges and High Kicks", "Week 2:Bridges and High Kicks", "Week 3:Bridges and High Kicks", "Week 1:Turns and Leaps", "Week 2:Turns and Leaps", "Week 3:Turns and Leaps", "Week 1:Advanced Jumping and Coordination", "Week 2:Advanced Jumping and Coordination", "Week 3:Advanced Jumping and Coordination", "Week 1:Rhythm Gymnastics and Cartwheel", "Week 2:Rhythm Gymnastics and Cartwheel", "Week 3:Rhythm Gymnastics and Cartwheel", "Week 1:Rolls and Extension passes", "Week 2:Rolls and Extension passes", "Week 3:Rolls and Extension passes", "Week 1:Cartwheel Extensions and Jumps", "Week 2:Cartwheel Extensions and Jumps", "Week 3:Cartwheel Extensions and Jumps", "Week 1:Advanced Fundamentals and Rhythm Gymnastics", "Week 2:Advanced Fundamentals and Rhythm Gymnastics", "Week 3:Advanced Fundamentals and Rhythm Gymnastics", "Week 1:Advanced Balance and Rolls", "Week 2:Advanced Balance and Rolls", "Week 3:Advanced Balance and Rolls", "Week 1:Creative Routine Building & Educator Show", "Week 2:Creative Routine Building & Educator Show", "Week 3:Creative Routine Building & Educator Show"]
const offerGymnastics = ["Week 4:Balance/Coordination", "Week 7:Jumping and Roll Introduction", "Week 16:Handstands + Cartwheel Introduction", "Week 25:Turns and Leaps"]
const yoga = [
    "Week 1:Yoga Poses", "Week 2:Yoga Poses", "Week 3:Yoga Poses",
    "Week 1:Mindfulness", "Week 2:Mindfulness", "Week 3:Mindfulness",
    "Week 1:Balance Skills", "Week 2:Balance Skills", "Week 3:Balance Skills",
    "Week 1:Yoga Games", "Week 2:Yoga Games", "Week 3:Yoga Games",
    "Week 1:Breathing Exercises", "Week 2:Breathing Exercises", "Week 3:Breathing Exercises",
    "Week 1:Yoga Stories", "Week 2:Yoga Stories", "Week 3:Yoga Stories",
    "Week 1:Animal Poses", "Week 2:Animal Poses", "Week 3:Animal Poses",
    "Week 1:Partner Yoga", "Week 2:Partner Yoga", "Week 3:Partner Yoga",
    "Week 1:Relaxation Techniques", "Week 2:Relaxation Techniques", "Week 3:Relaxation Techniques",
    "Week 1:Yoga Songs and Music", "Week 2:Yoga Songs and Music", "Week 3:Yoga Songs and Music",
    "Week 1:Yoga for Concentration", "Week 2:Yoga for Concentration", "Week 3:Yoga for Concentration",
    "Week 1:Stretching Routines", "Week 2:Stretching Routines", "Week 3:Stretching Routines",
    "Week 1:Yoga Challenges", "Week 2:Yoga Challenges", "Week 3:Yoga Challenges",
    "Week 1:Creative Expression Through Yoga", "Week 2:Creative Expression Through Yoga", "Week 3:Creative Expression Through Yoga",
    "Week 1:Seasonal Yoga", "Week 2:Seasonal Yoga", "Week 3:Seasonal Yoga",
    "Week 1:Celebrating Progress and Reflection", "Week 2:Celebrating Progress and Reflection", "Week 3:Celebrating Progress and Reflection",
]
const offerYoga = yoga.slice(0, 4)
const sensory = [
    "Week 1:Exploring Sound and Movement", "Week 2:Exploring Sound and Movement", "Week 3:Exploring Sound and Movement",
    "Week 1:Movement and motion", "Week 2:Movement and motion", "Week 3:Movement and motion",
    "Week 1:Lights and shadows", "Week 2:Lights and shadows", "Week 3:Lights and shadows",
    "Week 1:Soft Touch and Texture", "Week 2:Soft Touch and Texture", "Week 3:Soft Touch and Texture",
    "Week 1:Nature Explores", "Week 2:Nature Explores", "Week 3:Nature Explores",
    "Week 1:Colours", "Week 2:Colours", "Week 3:Colours",
    "Week 1:Earth Explores", "Week 2:Earth Explores", "Week 3:Earth Explores",
    "Week 1:Emotions", "Week 2:Emotions", "Week 3:Emotions",
    "Week 1:Soft Sounds and Lullabies", "Week 2:Soft Sounds and Lullabies", "Week 3:Soft Sounds and Lullabies",
    "Week 1:Cause and Effect", "Week 2:Cause and Effect", "Week 3:Cause and Effect",
    "Week 1:Sensory Safari", "Week 2:Sensory Safari", "Week 3:Sensory Safari",
    "Week 1:Pop, Push, Squish, Pull & Splash", "Week 2:Pop, Push, Squish, Pull & Splash", "Week 3:Pop, Push, Squish, Pull & Splash",
    "Week 1:Wiggle & Wonder", "Week 2:Wiggle & Wonder", "Week 3:Wiggle & Wonder",
    "Week 1:Tactile Explores", "Week 2:Tactile Explores", "Week 3:Tactile Explores",
    "Week 1:Tiny Builders", "Week 2:Tiny Builders", "Week 3:Tiny Builders",
    "Week 1:Touch, Tap & Pop", "Week 2:Touch, Tap & Pop", "Week 3:Touch, Tap & Pop",
]
const offerSensory = sensory.slice(0, 4)


const startWeekIndexOfYear = 4


const findIndex = (array, index) => {
    let matchingIndex = index
    while (matchingIndex >= array.length) {
        matchingIndex = matchingIndex - array.length
    }
    return matchingIndex
}

const getWeekActivityByCalendarWeek = (activities, weekIndex) => {
    const normalizedIndex = Math.max(0, weekIndex - startWeekIndexOfYear)
    return activities[findIndex(activities, normalizedIndex)] || ''
}


export const findCurrentWeekActivity = (date, activity, index, fastTrackType,) => {
    return resolveWeekActivity(date, activity, index, fastTrackType).weekActivity
}

export const resolveWeekActivity = (date, activity, index, fastTrackType,) => {
    const weekIndex = getWeek(new Date(date))
    const fastTrackTypeVal = fastTrackType ? (fastTrackType.value || fastTrackType) : ''

    switch (activity) {
        case 'Sports One':
            return { weekActivity: getWeekActivityByCalendarWeek(sportsOne, weekIndex), fastTrackType: '' }
        case 'Sports Two':
            return { weekActivity: getWeekActivityByCalendarWeek(sportsTwo, weekIndex), fastTrackType: '' }
        case 'Offer Sports 1':
            return { weekActivity: offerSportsOne[findIndex(offerSportsOne, index)] || '', fastTrackType: '' }
        case 'Offer Sports 2':
            return { weekActivity: offerSportsTwo[findIndex(offerSportsTwo, index)] || '', fastTrackType: '' }
        case 'Music':
            if (fastTrackTypeVal) {
                const matchingFT = musicFastTracks[fastTrackTypeVal]
                if (matchingFT && matchingFT[index]) {
                    return { weekActivity: matchingFT[index], fastTrackType: fastTrackTypeVal }
                }
            }
            return { weekActivity: getWeekActivityByCalendarWeek(music, weekIndex), fastTrackType: '' }
        case 'Offer Music':
            return { weekActivity: offerMusic[findIndex(offerMusic, index)] || '', fastTrackType: '' }
        // // Music starts specifically from the date the course starts. So we do based on index.
        // if (index >= music.length) {
        //     return music[findIndex(music, index)]
        // }
        // return music[index]
        case 'Gymnastics':
            if (fastTrackTypeVal) {
                const matchingFT = gymFastTracks[fastTrackTypeVal]
                if (matchingFT && matchingFT[index]) {
                    return { weekActivity: matchingFT[index], fastTrackType: fastTrackTypeVal }
                }
            }
            return { weekActivity: getWeekActivityByCalendarWeek(gymnastics, weekIndex), fastTrackType: '' }
        case 'Offer Gymnastics':
            return { weekActivity: offerGymnastics[findIndex(offerGymnastics, index)] || '', fastTrackType: '' }
        // Gymnastics starts specifically from the date the course starts. So we do based on index.
        // if (index >= gymnastics.length) {
        //     return gymnastics[findIndex(gymnastics, index)]
        // }
        // return gymnastics[index]
        case 'Yoga':
            // Yoga starts specifically from the date the course starts. So we do based on index.
            if (index >= yoga.length) {
                return { weekActivity: yoga[findIndex(yoga, index)], fastTrackType: '' }
            }
            return { weekActivity: yoga[index], fastTrackType: '' }
        case 'Offer Yoga':
            return { weekActivity: offerYoga[findIndex(offerYoga, index)] || '', fastTrackType: '' }
        case 'Sensory Fusion':
            if (index >= sensory.length) {
                return { weekActivity: sensory[findIndex(sensory, index)], fastTrackType: '' }
            }
            return { weekActivity: sensory[index], fastTrackType: '' }
        case 'Offer Sensory':
            return { weekActivity: offerSensory[findIndex(offerSensory, index)] || '', fastTrackType: '' }
        default:
            return { weekActivity: '', fastTrackType: '' }
    }
}

export const getClassType = (activity, weekActivity) => {
    if (activity) {
        if (['Sports One', 'Sports Two', 'Offer Sports 1', 'Offer Sports 2'].includes(activity)) {
            return 'Sports'
        }
        if (['Trial Sports Pack 1', 'Trial Sports Pack 2'].includes(activity)) {
            return 'Sports'
        }
        if (activity === 'Trial Music') {
            return 'Music'
        }
        if (activity === 'Trial Gymnastics') {
            return 'Gymnastics'
        }
        if (activity === 'Trial Yoga') {
            return 'Yoga'
        }
        if (activity === 'Offer Music') {
            return 'Music'
        }
        if (activity === 'Offer Gymnastics') {
            return 'Gymnastics'
        }
        if (activity === 'Offer Yoga') {
            return 'Yoga'
        }
        if (['Sensory Fusion', 'Offer Sensory'].includes(activity)) {
            return 'Sensory Fusion'
        }
        return activity
    }
    if (sportsOne.includes(weekActivity) || sportsTwo.includes(weekActivity)) {
        return 'Sports'
    } else if (music.includes(weekActivity)) {
        return 'Music'
    } else if (gymnastics.includes(weekActivity)) {
        return 'Gymnastics'
    } else if (yoga.includes(weekActivity)) {
        return 'Yoga'
    } else if (sensory.includes(weekActivity)) {
        return 'Sensory Fusion'
    }
    return '-'
}


export const checkEmailInValid = (email) => !email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)

// export const stripeKey = 'pk_test_51IEAtPHGNIVLJXiDSX21G0CSUUNBryCUmljsvimwr6GrsRzKCMBgpdYRiZSejn3getVzXiImB0q6jEzTzDSJrcPd00I4Zk8IBZ' // Test Key
export const stripeKey = 'pk_live_51IEAtPHGNIVLJXiD9RoxWKy5KVHUJHHsV3XLuN7f6WAexeWJPfEkSaC7t731IVsphXracpCmpxjZghJAhBXlRX5n00c4jMkAU7' // Live Key


export const updateHoursAndMinutesAndDay = (newDate, originalDate, daysDifference) => {
    const updatedHour = newDate.setHours(originalDate.getHours())
    const updatedMins = new Date(updatedHour).setMinutes(originalDate.getMinutes())
    return addDays(new Date(updatedMins), daysDifference)
}
